import { createSlice } from "@reduxjs/toolkit";
import type { KnowledgeDraftFieldChange } from "pages/ClarkKnowledge/draft-diff";
import type { AppState } from "store/types";

type KnowledgeState = {
  pendingSaveKnowledgePreview?: {
    changes: KnowledgeDraftFieldChange[];
    knowledgeName?: string;
    knowledgeId?: string;
  };
  saveKnowledgePreviewByToolCallId: Record<
    string,
    {
      changes: KnowledgeDraftFieldChange[];
      knowledgeName?: string;
      knowledgeId?: string;
    }
  >;
};

const initialState: KnowledgeState = {
  saveKnowledgePreviewByToolCallId: {},
};

export const knowledgeSlice = createSlice({
  name: "knowledge",
  initialState,
  reducers: {
    setPendingSaveKnowledgePreview: (
      state,
      action: {
        payload: {
          changes: KnowledgeDraftFieldChange[];
          knowledgeName?: string;
          knowledgeId?: string;
        };
      },
    ) => {
      state.pendingSaveKnowledgePreview = action.payload;
    },
    clearPendingSaveKnowledgePreview: (state) => {
      state.pendingSaveKnowledgePreview = undefined;
    },
    attachPendingSavePreviewToToolCallId: (
      state,
      action: {
        payload: {
          toolCallId: string;
        };
      },
    ) => {
      if (!state.pendingSaveKnowledgePreview) {
        return;
      }
      state.saveKnowledgePreviewByToolCallId[action.payload.toolCallId] =
        state.pendingSaveKnowledgePreview;
      state.pendingSaveKnowledgePreview = undefined;
    },
  },
});

export const {
  setPendingSaveKnowledgePreview,
  clearPendingSaveKnowledgePreview,
  attachPendingSavePreviewToToolCallId,
} = knowledgeSlice.actions;

export const selectPendingSaveKnowledgePreview = (state: AppState) =>
  state.knowledge.pendingSaveKnowledgePreview;

export const selectSaveKnowledgePreviewByToolCallId = (
  state: AppState,
  toolCallId: string | undefined,
) =>
  toolCallId
    ? state.knowledge.saveKnowledgePreviewByToolCallId[toolCallId]
    : undefined;
